import { Scene } from "phaser";


export class MainScene extends Scene {
    player = null;
    enemy_blue = null;
    cursors = null;

    points = 0;
    game_over_timeout = 20;

    constructor() {
        super("MainScene");
    }

    init() {
        //this.cameras.main.fadeIn(500, 0, 0, 0);
        
      

        // Reset points
        this.points = 0;
        this.game_over_timeout = 20;
    }

    create() {
        
        this.registry.set('user_name', '');
        this.registry.set('user_balance', 0);
        this.registry.set('cart_amount', 0);
        this.registry.set('cart_items', []);

        //this.registry.events.on('changedata', this.updateData, this);

        // // this.intro = this.add.video(0, 0, 'sword').setOrigin(0).setDisplaySize(this.scale.width, this.scale.height);
        // // console.log(this.scale.width, this.scale.height)
        // // this.intro.setDisplaySize(this.scale.width, this.scale.height);
        // // this.intro.play(true);
        // this.intro = this.add.image(this.scale.width/2, this.scale.height/2, 'lotto-bg').setOrigin(0.5).setTint(0x999999);
        // this.intro.setScale(0.5)
        // //this.intro.setScale()
        // //this.intro.setDisplaySize(this.scale.width,this.scale.height);
        // this.intro.preFX.addBlur(2,0.5,0.5,1);




         // Get the game width and height (viewport dimensions)
         const { width, height } = this.scale;

         // Add the background image to the scene
         const bg = this.add.image(width / 2, height / 2, 'lotto-bg');
         bg.setTint(0x666666)
         bg.setOrigin(0.5, 0);
         // Scale the background to fill the width and height of the game
         bg.setDisplaySize(this.scale.width, this.scale.height);

 
        //  // Calculate the aspect ratio of the image and the viewport
        //  const bgWidth = bg.width;
        //  const bgHeight = bg.height;
        //  const bgAspectRatio = bgWidth / bgHeight;
 
        //  // Resize the background image based on the height of the viewport
        //  bg.setDisplaySize(height * bgAspectRatio, height);
 
        //  // If the background doesn't cover the full width, adjust it to fill the width
        //  if (bg.displayWidth < width) {
        //      bg.setDisplaySize(width, width / bgAspectRatio);
        //  }
 
        //  // Center the background image
        //  bg.setPosition(width / 2, height / 2);
 
        //  // Listen for resize events and adjust the background size dynamically
        //  this.scale.on('resize', (gameSize) => {
        //      const { width, height } = gameSize;
        //      bg.setDisplaySize(height * bgAspectRatio, height);
        //      if (bg.displayWidth < width) {
        //          bg.setDisplaySize(width, width / bgAspectRatio);
        //      }
        //      bg.setPosition(width / 2, height / 2);
        //  });


         bg.preFX.addBlur();


        // Create a render texture with the same size as the game
        const renderTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);

        // Draw the background image with PreFX onto the render texture
        renderTexture.draw(bg, this.scale.width/ 2,0);//bg.x - bg.width / 2, bg.y

        // Save the render texture as a new Phaser texture
        renderTexture.saveTexture('blurredBackground', renderTexture.texture);

        // Remove the original background image
        bg.destroy();

        // Add the new texture to the game as a sprite or image
        const newBackground = this.add.image(this.scale.width / 2, 0, 'blurredBackground')
            .setOrigin(0.5, 0)
            .setDisplaySize(this.scale.width, this.scale.height);


         this.scene.launch("MenuScene");
         this.scene.launch("HudScene");
         

    
       
        
    }

    update() {
        // this.player.update();
        // this.enemy_blue.update();

        // // Player movement entries
        // if (this.cursors.up.isDown) {
        //     this.player.move("up");
        // }
        // if (this.cursors.down.isDown) {
        //     this.player.move("down");
        // }
        //this.intro.setDisplaySize(this.scale.width, this.scale.height);
        //this.intro.setDisplaySize(this.scale.width, this.scale.height);
        //this.SecondBG.setDisplaySize(this.scale.width, this.scale.height);
    }
}